(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wisertrail-map-offer"] && !Shopify.designMode) return;
  try {
    (()=>{
    const root=document.querySelector('[data-wt-map-offer]');
    if(!root)return;
    const productForm=document.querySelector('main product-form');
    if(productForm)productForm.before(root);
    const dialog=root.querySelector('dialog');
    let opener;
    let timer;
    let purchaseStarted=false;
    const key='wt-map-offer-seen-v1';
    const show=(manual=false)=>{
      if(!dialog.showModal||dialog.open)return;
      const otherModal=Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"]')).some(el=>{
        const style=getComputedStyle(el);
        const details=el.closest('details');
        return el!==dialog&&(!details||details.open)&&el.getClientRects().length>0&&style.visibility==='visible'&&style.opacity!=='0'&&!el.closest('[hidden],[aria-hidden="true"]');
      });
      if(!manual&&otherModal)return;
      opener=document.activeElement;
      dialog.showModal();
      try{sessionStorage.setItem(key,'1')}catch(e){}
    };
    root.querySelector('[data-wt-map-open]').addEventListener('click',()=>show(true));
    root.querySelectorAll('[data-wt-map-close]').forEach(button=>button.addEventListener('click',()=>dialog.close()));
    dialog.addEventListener('close',()=>{if(opener&&opener.focus)opener.focus()});
    dialog.addEventListener('click',event=>{if(event.target===dialog){const box=dialog.getBoundingClientRect();if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom)dialog.close()}});
    document.addEventListener('submit',event=>{
      if(event.target.action&&event.target.action.includes('/cart/add')){
        purchaseStarted=true;
        clearTimeout(timer);
      }
    },true);
    const schedule=()=>{timer=setTimeout(()=>{
      if(purchaseStarted)return;
      if(document.visibilityState!=='visible')return;
      try{if(sessionStorage.getItem(key))return}catch(e){return}
      if(document.activeElement&&/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName))return;
      show();
    },10000)};
    if(!window.Shopify?.designMode)document.addEventListener('pointerdown',schedule,{once:true,passive:true});
  })();
  } catch(e) { console.error(e); }
})();

})();
